import Images from 'assets/img';

export function getWeight(weight) {
  if (typeof weight === 'string' || weight instanceof String) {
    const formattedWeight = parseFloat(weight);

    if (formattedWeight > 1000) {
      return `${(formattedWeight / 1000).toFixed(2)} Ton`;
    }
    if (formattedWeight < 1) {
      return `${(formattedWeight * 1000).toFixed(2)} g`;
    }
    return `${formattedWeight} kg`;
  }
  if (weight > 1000) {
    return `${(weight / 1000).toFixed(2)} Ton`;
  }
  if (weight < 1) {
    return `${(weight * 1000).toFixed(2)} g`;
  }
  return `${weight} kg`;
}

export function getValue(value) {
  // Se for null ou undefined, retornar string vazia
  if (value === null || value === undefined) {
    return '';
  }
  
  // Se for string, tentar converter para número
  if (typeof value === 'string' || value instanceof String) {
    // Remover caracteres de formatação e converter para número
    const cleanedValue = value.replace('R$', '').replace(/\./g, '').replace(',', '.').trim();
    const formattedValue = parseFloat(cleanedValue);
    
    // Se não for um número válido, retornar string vazia
    if (isNaN(formattedValue)) {
      return '';
    }

    return Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(formattedValue);
  }
  
  // Se for número, formatar diretamente
  if (typeof value === 'number') {
    return Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  }
  
  // Para outros tipos, tentar converter para número
  const numValue = parseFloat(value);
  if (!isNaN(numValue)) {
    return Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(numValue);
  }
  
  // Se não conseguir converter, retornar string vazia
  return '';
}

export function formatDate(date) {
  const formattedDate = new Date(date);

  return formattedDate.toLocaleDateString('pt-BR');
}

export function capitalize(string) {
  if (string !== null && string !== undefined) {
    const strings = string.toString().toLowerCase().split(' ');
    let formattedString = '';
    strings.forEach((item) => {
      item = item.trim();
      if (item !== strings[strings.length - 1]) {
        formattedString += `${item.charAt(0).toUpperCase() + item.slice(1)} `;
      } else {
        formattedString += item.charAt(0).toUpperCase() + item.slice(1);
      }
    });

    return formattedString;
  }
  return '';
}

export function zipcode(string) {
  if (!string) return '';
  const cleaned = string.toString().replace('.', '').replace('-', '');
  if (cleaned.length < 5) return cleaned;
  return `${cleaned.substring(0, 5)}-${cleaned.substring(5)}`;
}

export function getImgType(type) {
  switch (type) {
    case 'Carga Granel':
      return Images.AgriculturalFlag;
    case 'Carga Perigosa':
      return Images.DangerousFlag;
    case 'Carga Frigorificada':
      return Images.ColdFlag;
    case 'Carga Viva':
      return Images.AnimalFlag;
    case 'Carga Solta':
      return Images.WoodFlag;
    case 'Carga Unitizada':
      return Images.BoxFlag;
    case 'Carga Animal':
      return Images.PetFlag;
    case 'Carga Inflamável':
      return Images.FlammableFlag;
    case 'Carga Química':
      return Images.ChemicalFlag;
    default:
      return Images.GeneralFlag;
  }
}
